import {COMPETITION_CONTAINER} from "../../../../../containers/competition-container/competition-container.consts";
import {computed} from "mobx";
import {ANALYTICS} from "../../../../../third-party-services/analytics/analytics-consts";
import {MatchesTabModel} from "../matches.tab-model";
import {CompetitionViewModel} from "../../../../../domain/common/competition/models/competition-view-model";
import {BaseLinkModel} from "../../../../../infrastructure/models/link/base-link-model";
import {OLYMPICS_COMPETITION_IDS} from "../../../../../core/app/consts";
import {CompetitionMedalsPageLinkModel} from "../../../../../containers/competition-container/pages/medals-page/models/competition-medals-page.link-model";

export class CompetitionMedalsPageTabModel extends MatchesTabModel {
  index: Number;
  name: String;
  entity: CompetitionViewModel;
  currentLinkModel: BaseLinkModel;

  constructor(
    index: Number,
    name: String,
    entity: CompetitionViewModel,
    currentLinkModel: BaseLinkModel,
    isWidget: BaseLinkModel
  ) {
    super(index, name, isWidget)

    this.entity = entity;
    this.currentLinkModel = currentLinkModel;
  }

  @computed get linkModel(): CompetitionMedalsPageLinkModel {
    const linkModel: CompetitionMedalsPageLinkModel = new CompetitionMedalsPageLinkModel(this.entity.id, this.entity.sport.nameForURL, this.entity.nameForURL, this.entity.isFollow);

    return linkModel;
  }

  get isVisible(): Boolean {
    return OLYMPICS_COMPETITION_IDS.includes(this.entity.id);
  }

  get isActive(): Boolean {
    return this.currentLinkModel.params.page === COMPETITION_CONTAINER.FILTERS.medals;
  }

  get analyticsEntityType(): Object {
    return ANALYTICS.ENTITY_TYPES.competition;
  }

  get elementId(): String {
    return 'navigation-tabs_competition_medals';
  }
}
